import {useMemo} from 'react'
import {graphql, useSubscription} from 'react-relay'

import type {IssueRowSubscription} from './__generated__/IssueRowSubscription.graphql'

// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
const subscription = graphql`
  subscription IssueRowSubscription($issueId: ID!) {
    issueUpdated(id: $issueId) {
      issueTitleUpdated {
        title
        titleHTML
      }
      issueStateUpdated {
        state
        stateReason
      }
      issueTypeUpdated {
        issueType {
          id
          name
          color
        }
      }
      issueMetadataUpdated {
        ...IssuePullRequestTitle @arguments(labelPageSize: 20)
        ...Assignees @arguments(assigneePageSize: 10)
        ...MilestonesSectionMilestone

        projectItems(first: 10) {
          edges {
            node {
              id
              project {
                # eslint-disable-next-line relay/unused-fields
                id
                # eslint-disable-next-line relay/unused-fields
                title
                # eslint-disable-next-line relay/unused-fields
                closed
                # eslint-disable-next-line relay/unused-fields
                number
                # eslint-disable-next-line relay/unused-fields
                url
                # eslint-disable-next-line relay/unused-fields
                viewerCanUpdate
                # eslint-disable-next-line relay/unused-fields
                hasReachedItemsLimit
                # eslint-disable-next-line relay/unused-fields
                __typename
              }
            }
          }
        }
      }
    }
  }
`

const useIssueRowSubscription = (issueId: string) => {
  const config = useMemo(() => {
    return {
      subscription,
      variables: {issueId},
    }
  }, [issueId])

  useSubscription<IssueRowSubscription>(config)
}

export function IssueRowSubscriber({issueId}: {issueId: string}) {
  useIssueRowSubscription(issueId)
  return null
}
